module.exports = require('./dist/bundle')